export const APP_LAYOUT_PREVIEW_PATH = 'appLayoutPreview';

export const appLayoutPreviewIds = [
    'default',
    'subNavigation',
    'subNavigationWithoutOffset',
    'bodyBanner',
    'bottomBar',
    'sidebar',
    'complete',
] as const;

export type AppLayoutPreviewId = (typeof appLayoutPreviewIds)[number];
